import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useQualityServiceFeeEnabled() {
  const { market } = useMarketplace()
  const {
    FF_ENABLE_QUALITY_SERVICE_FEE_COUNTRIES = '',
    FF_ENABLE_QUALITY_SERVICE_FEE_COUNTRIES_TOP = '',
  } = useRuntimeConfig().public

  const isQualityServiceFeeEnabled = computed(() =>
    FF_ENABLE_QUALITY_SERVICE_FEE_COUNTRIES.includes(market.countryCode),
  )

  const isQualityServiceFeeEnabledTop = computed(() =>
    FF_ENABLE_QUALITY_SERVICE_FEE_COUNTRIES_TOP.includes(market.countryCode),
  )

  return { isQualityServiceFeeEnabled, isQualityServiceFeeEnabledTop }
}
